<sb-logo-layout-wrapper>
  <sb-stores-create />
</sb-logo-layout-wrapper>
